import React from 'react';

import debounce from 'lodash/debounce';

import { FilterType } from 'components/Grid/types';

const SEARCH_DEBOUNCE_MS = 300;

export interface MemberSearch {
  searchQuery: string;
  temporaryFilters: FilterType[];
  onSearchChange: (value: string) => void;
  resetSearch: () => void;
}

export const useMemberSearch = (): MemberSearch => {
  const [searchQuery, setSearchQuery] = React.useState('');
  const [debouncedQuery, setDebouncedQuery] = React.useState('');

  const debouncedSetQuery = React.useMemo(() => debounce(setDebouncedQuery, SEARCH_DEBOUNCE_MS), []);
  React.useEffect(() => () => debouncedSetQuery.cancel(), [debouncedSetQuery]);

  const onSearchChange = React.useCallback(
    (value: string) => {
      setSearchQuery(value);
      debouncedSetQuery(value);
    },
    [debouncedSetQuery]
  );

  const resetSearch = React.useCallback(() => {
    setSearchQuery('');
    setDebouncedQuery('');
    debouncedSetQuery.cancel();
  }, [debouncedSetQuery]);

  const temporaryFilters = React.useMemo<FilterType[]>(
    () => (debouncedQuery ? [{ field: 'query', operator: 'is', value: debouncedQuery }] : []),
    [debouncedQuery]
  );

  return { searchQuery, temporaryFilters, onSearchChange, resetSearch };
};
